var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('figcaption',{class:[
    _vm.$options.defaultClass,
    _vm.$options.name,
    ( _obj = {}, _obj[("" + _vm.styleClass)] = _vm.styleClass, _obj ),
    {'inline':_vm.inline}]},[_c('span',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.caption)}}),_vm._v(" "),_c('span',{staticClass:"credit",domProps:{"innerHTML":_vm._s(_vm.credit)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }